import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const PencilRulerIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M8.615 3H7.128L3 7.128v1.487L15.385 21h1.487L21 16.872v-1.487l-1.734-1.734-2.807 2.808-1.486-1.487 2.807-2.807-2.313-2.312-2.807 2.807-1.486-1.486 2.807-2.807-2.146-2.147-2.807 2.807L7.54 7.541l2.807-2.807L8.615 3ZM18.216 9.723l2.76-2.76V5.478L18.498 3h-1.486l-2.76 2.76 3.964 3.963ZM5.059 14.954l.7-.702 3.964 3.964-.7.7-.485.276-3.322.845L3.94 18.76l.844-3.322.276-.484Z"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "m20.976 6.963-2.76 2.76-1.486-1.486 1.922-1.923-.99-.99-1.923 1.922-1.486-1.486L17.013 3h1.486l2.477 2.477v1.486ZM5.76 14.252l-.7.701-.276.484-.845 3.322 1.278 1.278 3.321-.845.485-.275.7-.701-1.486-1.487-.497.497-1.328.338.338-1.329.496-.496-1.486-1.487Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M7.128 3h1.487L21 15.386v1.486L16.872 21h-1.487L3 8.615V7.129L7.128 3Zm.744 2.23L5.229 7.872l10.9 10.899 2.642-2.642-.991-.991-1.321 1.32-1.486-1.485 1.32-1.321-2.229-2.23-1.32 1.321-1.487-1.486 1.32-1.321-2.229-2.23-1.32 1.322L7.54 7.54l1.321-1.32-.99-.991Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    console.error(
      `PencilRulerIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { PencilRulerIcon };
//# sourceMappingURL=PencilRulerIcon.mjs.map
